import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Order } from '../models/order';
import { UtilitiesService } from './utilities.service';
import { User } from '../models/user';

export interface OrderFilters {
  status:string,
  date1:Date,
  date2:Date,
  user:number,
}

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http:HttpClient, private utl:UtilitiesService) { }
  
  async getOrders(filters?:OrderFilters) : Promise<Order[]> {
    if(filters) {
      let filtros:string = "";
      if(filters.status) {
        filtros += "status=" + filters.status;
      }
      if(filters.user) {
        filtros += filtros == "" ?  "user=" + filters.user : "&user=" + filters.user;
      }
      if(filters.date1) {
        filtros += filtros == "" ? "date1=" + filters.date1 : "&date1=" + filters.date1;
      }
      if(filters.date2) {
        filtros += filtros == "" ? "date2=" + filters.date2 : "&date2=" + filters.date2;
      }
      return this.http.get<Order[]>('/api/order?' + filtros)
        .toPromise();
    } else {
      return this.http.get<Order[]>('/api/order')
        .toPromise();
    }
  }
  async travelOrders(filters?:OrderFilters) : Promise<any> {
    if(filters) {
      let filtros:string = "";
      if(filters.status) {
        filtros += "status=" + filters.status;
      }
      if(filters.user) {
        filtros += filtros == "" ?  "user=" + filters.user : "&user=" + filters.user;
      }
      if(filters.date1) {
        filtros += filtros == "" ? "date1=" + filters.date1 : "&date1=" + filters.date1;
      }
      if(filters.date2) {
        filtros += filtros == "" ? "date2=" + filters.date2 : "&date2=" + filters.date2;
      }
      return this.http.get<Order[]>('/api/travelOrders?' + filtros)
        .toPromise();
    } else {
      return this.http.get<Order[]>('/api/travelOrders')
        .toPromise();
    }
  }
  async getPlants() : Promise<Order[]> {
    
    return this.http.get<Order[]>('/api/getPlants')
      .toPromise();
  }

  getOrder(id:Number) : Promise<Order> {
    return this.http.get<Order>('/api/order/' + id)
      .toPromise();
  }

  async postOrder(order:Order) : Promise<Order> {
    return this.http.post<Order>('/api/order', order)
      .toPromise();
  }

  putOrder(order:Order) : Promise<Order> {
    return this.http.post<Order>('/api/order/' + order.id + '/edit', order)
      .toPromise();
  }

  async deleteOrder(order:Order) : Promise<void>{
    return this.http.get<void>('/api/order/' + order.id + '/delete').toPromise();
  }

}
